import { Injectable } from '@angular/core';
import Cookies from 'js-cookie';
import { UTMParameters } from '../api';

@Injectable({
  providedIn: 'root',
})
export class UtmService {
  public getUTMParameters(): UTMParameters {
    let cookie = Cookies.get('iqfl_l');

    if (cookie) {
      let values = JSON.parse(cookie);
      return {
        source: values.utm_source,
        campaign: values.utm_campaign,
        medium: values.utm_medium,
      };
    }
    return {};
  }
}
